import React from "react";
import CodeEditor from "../../../../../../components/elements/CodeEditor";
import CustomSelect from "../../../../../../components/elements/CustomSelect";

const WORKSPACES = [
    "html",
    "html_css",
    "html_css_js",
];

export default function CodeWebLanguageEditor({ value, onChange }) {

    const config = value?.config || {};
    const files = config.files || {};

    const updateConfig = (patch) => {
        onChange({
            ...value,
            config: {
                ...config,
                ...patch,
            },
        });
    };

    const updateFile = (name, code) => {
        updateConfig({
            files: {
                ...files,
                [name]: code,
            },
        });
    };

    return (
        <div className="flex flex-col gap-8 p-5 bg-gray-200 rounded-lg">

            <CustomSelect
                value={config.workspace || "html_css_js"}
                options={WORKSPACES}
                onChange={(e) =>
                    updateConfig({
                        workspace: e.target.value,
                    })
                }
            />

            <CodeEditor
                value={files.html || ""}
                language="html"
                onChange={(code) => updateFile("html", code)}
            />

            {(config.workspace === "html_css" ||
                config.workspace === "html_css_js") && (
                <CodeEditor
                    value={files.css || ""}
                    language="css"
                    onChange={(code) => updateFile("css", code)}
                />
            )}

            {config.workspace === "html_css_js" && (
                <CodeEditor
                    value={files.js || ""}
                    language="javascript"
                    onChange={(code) => updateFile("js", code)}
                />
            )}
        </div>
    );
}